import { render } from "./DetalharNivelTurma.vue?vue&type=template&id=7902c386&scoped=true"
import script from "./DetalharNivelTurma.vue?vue&type=script&lang=js"
export * from "./DetalharNivelTurma.vue?vue&type=script&lang=js"

import "./DetalharNivelTurma.vue?vue&type=style&index=0&id=7902c386&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7902c386"]])

export default __exports__